module.exports = __webpack_public_path__ + "img/logo_telegram.894018a5.svg";